import { HTTP } from "./http";

const API_SERVER = "/personal-training-BE/back-end-endpoint-app-activity.php";

/**
 * App Activity (admin usage/adoption reporting).
 * Backend is tier-gated (appActivity) + admin-only.
 */
export const AppActivity = {
  /**
   * Per-member adoption board for a club (optionally one team).
   * @param {string} clubId           logged-in profile's clubId
   * @param {number} requestingUserId the admin making the request (server verifies)
   * @param {number|null} teamId      optional team filter
   */
  getAppActivity(clubId, requestingUserId, teamId = null) {
    return HTTP.post(API_SERVER, {
      action: "getAppActivity",
      club_id: clubId,
      requesting_user_id: requestingUserId,
      team_id: teamId,
    });
  },

  /**
   * Record that this profile opened the web app. Best-effort, throttled to
   * one event per user per calendar day (client-side), stamped with the
   * currently-selected profile id (parent-child: the active child, not the
   * shared login). Never throws.
   */
  logAppOpen(profile) {
    if (!profile || !profile.id) return;
    const today = new Date().toISOString().slice(0, 10);
    const key = `app_open_${profile.id}`;
    try {
      if (localStorage.getItem(key) === today) return; // already logged today
      localStorage.setItem(key, today);
    } catch (e) {
      /* private mode / storage disabled — proceed without throttle */
    }
    // main.js stores the running build's version.json version here on boot.
    let appVersion = null;
    try {
      appVersion = localStorage.getItem("app_version") || null;
    } catch (e) {
      /* storage disabled */
    }
    HTTP.post(API_SERVER, {
      action: "logAppOpen",
      user_id: profile.id,
      club_id: profile.clubId,
      team_id: profile.teamId,
      event_type: "app_open",
      event_key: "web",
      app_version: appVersion,
    }).catch(() => {});
  },
};
